import axios from 'axios';

const api = axios.create({
  baseURL: "https://hospital-service.swasthyakhata.com/"
});

export default api;